import { render } from "./portfolio-calculate.vue?vue&type=template&id=1a3c5128&scoped=true&ts=true"
import script from "./portfolio-calculate.vue?vue&type=script&lang=ts"
export * from "./portfolio-calculate.vue?vue&type=script&lang=ts"

import "./portfolio-calculate.vue?vue&type=style&index=0&id=1a3c5128&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3c5128"]])

export default __exports__